const ASYNC_LOADING = 'ASYNC_LOADING';
const AUTH_FAILURE = 'AUTH_FAILURE';
const POST_SUCCESS = 'POST_SUCCESS';
const SET_QUESTIONS = 'SET_QUESTIONS';
const DATA_SUCCESS = 'DATA_SUCCESS';
const UNHANDLED_ERROR = 'UNHANDLED_ERROR';
const SUCCESS_FINAL = 'SUCCESS_FINAL';
const TIMEOUT_FAILURE = 'TIMEOUT_FAILURE';
const SET_CCPA_MODEL = 'SET_CCPA_MODEL';
const FULL_FAILURE = 'FULL_FAILURE';
const SET_REQUEST_TYPE = 'SET_REQUEST_TYPE';
const CLEAR_DATA = 'CLEAR_DATA';
const FILE_ERROR = 'FILE_ERROR'

export {
    ASYNC_LOADING,
    AUTH_FAILURE,
    POST_SUCCESS,
    SET_QUESTIONS,
    DATA_SUCCESS,
    UNHANDLED_ERROR,
    SUCCESS_FINAL,
    TIMEOUT_FAILURE,
    SET_CCPA_MODEL,
    FULL_FAILURE,
    SET_REQUEST_TYPE,
    CLEAR_DATA,
    FILE_ERROR
};